import { takeLatest, call, put } from 'redux-saga/effects';
import { AssetAdminApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import { assignSerialNumberAction, validateSerialNumberAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';
import { getGatewayConnectedAssets, getGatewayInfo } from '../GatewayDetails/actions';
import { translate } from 'helpers/translateHelper';

function* validateSerialNumber(action) {
    const oldSerialNumber = action.payload?.oldSerialNumber;
    const newSerialNumber = action.payload?.newSerialNumber;
    const suffix = action.payload?.suffix;
    const isMultiModuleDrive = action.payload?.isMultiModuleDrive;

    yield put(validateSerialNumberAction(apiCallStatus.LOADING));
    try {
        const response = yield call(AssetAdminApi.validateSerialNumber, oldSerialNumber, newSerialNumber, suffix, isMultiModuleDrive);
        yield put(validateSerialNumberAction(apiCallStatus.SUCCESS, response));
        logger.debug('serialNumber successfully validated', response);
        if (response?.errorMessage) {
            notify(response.errorMessage, apiCallStatus.ERROR, true);
        }
    } catch (err) {
        yield put(validateSerialNumberAction(apiCallStatus.ERROR, [], err));
        logger.error('Error in validateSerialNumber', err);
    }
}

function* assignSerialNumber(action) {
    const requestBody = action.payload;
    yield put(assignSerialNumberAction(apiCallStatus.LOADING));
    try {
        const response = yield call(
            AssetAdminApi.assignSerialNumber,
            requestBody.assetId,
            requestBody.serialNumber,
            requestBody.cabinetSerialNumber,
            requestBody.suffix,
            requestBody.isMultiModuleDrive,
            requestBody.isApproved
        );
        yield put(assignSerialNumberAction(apiCallStatus.SUCCESS, response));
        logger.debug('Serial number successfully assigned');
        notify(translate('ABB.Powertrain.Frontend.gatewayManagementAssetDetailsChangeSaved'), NOTIFICATION_TYPES.SUCCESS);
        if (response?.errorMessage) {
            notify(response?.errorMessage, apiCallStatus.ERROR, true);
        } else if (requestBody?.gatewayID) {
            yield put(getGatewayInfo(requestBody?.gatewayID));
            yield put(getGatewayConnectedAssets(requestBody?.gatewayID));
        }
    } catch (err) {
        yield put(assignSerialNumberAction(apiCallStatus.ERROR, [], err));
        notify(err.message, apiCallStatus.ERROR, true);
        logger.error('Failed to assign serial number:', err);
    }
}

// eslint-disable-next-line import/no-unused-modules
export function* ValidateSerialNumberWatchers() {
    yield takeLatest(actionTypes.VALIDATE_SERIAL_NUMBER, validateSerialNumber);
}

// eslint-disable-next-line import/no-unused-modules
export function* AssignSerialNumberWatchers() {
    yield takeLatest(actionTypes.ASSIGN_SERIAL_NUMBER, assignSerialNumber);
}
